module.exports = __webpack_public_path__ + "img/after-atlas.358e80b3.png";